import React, { memo, useMemo } from 'react'
import { Modal } from '@mui/material'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { ImportMinor } from '@shopify/polaris-icons'
import { ModalHeader } from './ModalHeader'

interface Props {
  isOpen?: boolean
  title: string
  type?: string
  file?: any
  onClose(): void
}

const FilePreviewModalComponent = ({
  isOpen,
  file,
  title,
  type = 'application/pdf',
  onClose,
}: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur lg:p-4`}
      disableScrollLock
    >
      <div
        css={[tw`bg-shades-0 lg:rounded-lg overflow-hidden w-[724px] flex flex-col h-full`]}
        data-testid="shared-file-preview-modal"
      >
        <ModalHeader
          title={title}
          onClose={onClose}
          closeButtonTestId="shared-file-preview-modal-close-btn"
        />
        <object
          data={file + '#toolbar=0'}
          type={type}
          css={tw`w-full h-full`}
          data-testid="shared-file-preview-modal-object"
        >
          <p css={tw`m-4`}>
            Oops! Your browser doesn't support PDFs preview. But you can still download it!
          </p>
        </object>
        <div css={tw`[transform: translate(-50%, -50%)] bottom-6 left-1/2 absolute`}>
          <a href={file} download data-testid="shared-file-preview-modal-download-link">
            <Button
              size="small"
              rightIcon={<ImportMinor width={20} height={20} fill="white" />}
              data-testid="shared-file-preview-modal-download-btn"
            >
              Download
            </Button>
          </a>
        </div>
      </div>
    </Modal>
  )
}

export const FilePreviewModal = memo(FilePreviewModalComponent)
